import { useState } from "react";
import { Check, Copy, Download, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../ui/button";
import { StepTitle } from "./LoginShell";

// Shown ONCE after 2-step sign-in is switched on.
export const RecoveryCodes = ({ codes, onContinue }) => {
  const [saved, setSaved] = useState(false);
  const text = codes.join("\n");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Recovery codes copied");
    } catch {
      toast.error("Couldn't copy. Please write them down.");
    }
  };
  const download = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([`Duckify recovery codes (each works once)\n\n${text}\n`], { type: "text/plain" }));
    a.download = "duckify-recovery-codes.txt";
    a.click();
    URL.revokeObjectURL(a.href);
  };

  return (
    <div data-testid="recovery-codes" className="space-y-5">
      <StepTitle title="Keep these recovery codes">
        If you lose your phone, each code lets you sign in once. Store them somewhere safe: they won't be shown again.
      </StepTitle>
      <ol data-testid="recovery-codes-list" className="grid grid-cols-2 gap-2 rounded-2xl bg-[#1f1f24] p-4 font-mono2 text-sm text-[#ffc700]">
        {codes.map((c) => <li key={c} className="text-center">{c}</li>)}
      </ol>
      <div className="flex gap-2">
        <Button type="button" variant="outline" data-testid="recovery-copy-btn" onClick={copy} className="h-11 flex-1 rounded-full gap-2">
          <Copy className="h-4 w-4" /> Copy
        </Button>
        <Button type="button" variant="outline" data-testid="recovery-download-btn" onClick={download} className="h-11 flex-1 rounded-full gap-2">
          <Download className="h-4 w-4" /> Download
        </Button>
      </div>
      <label className="flex cursor-pointer items-center gap-2 text-sm text-[#3a3a40]">
        <input type="checkbox" data-testid="recovery-saved-checkbox" checked={saved} onChange={(e) => setSaved(e.target.checked)} className="h-4 w-4 accent-[#1f1f24]" />
        I've saved my recovery codes
      </label>
      <Button data-testid="recovery-continue-btn" disabled={!saved} onClick={onContinue} className="h-12 w-full rounded-full font-bold gap-2">
        {saved ? <Check className="h-4 w-4" /> : <ShieldCheck className="h-4 w-4" />} Continue
      </Button>
    </div>
  );
};
